// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__20KvP","Header__Title":"Header_Header__Title__3US9v"};